exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-send .invoice-send__error-list>h1 {\n  padding-bottom: 2rem;\n}\n\n.invoice-send .invoice-send__error-list>ul {\n  font-size: 3.6rem;\n  list-style-type: none;\n  padding: 2rem 0;\n  margin: 0;\n}\n\n.invoice-send .invoice-send__error-list>ul>li {\n  line-height: 5rem;\n}\n\n", ""]);

// exports
